import type { PlanType } from '@painpal/contracts';
import { colors, PLAN_COLORS } from '../../theme/tokens';
import { PLAN_LABELS } from './planModel';
import styles from './planTag.module.css';

export interface PlanTagProps { type: PlanType; missed?: boolean; outline?: boolean; size?: 'row' | 'strip' }

// A missed day's tag is quiet: paper fill, grey stroke and text, struck through, never hot.
// A suggested block is an outline in its zone colour until it's added (Rest keeps its grey line).
export function PlanTag({ type, missed = false, outline = false, size = 'row' }: PlanTagProps) {
  const style = outline
    ? { background: colors.paper, borderColor: type === 'rest' ? undefined : PLAN_COLORS[type] }
    : { background: missed ? colors.paper : PLAN_COLORS[type] };
  return (
    <span className={styles.tag} data-type={type} data-missed={missed || undefined} data-outline={outline || undefined} data-size={size} style={style}>
      {PLAN_LABELS[type]}
    </span>
  );
}
